/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { AxiosHttpRequest } from './core/AxiosHttpRequest';

import { AiConceptsService } from './services/AiConceptsService';
import { ApiKeysService } from './services/ApiKeysService';
import { AssetAccountsService } from './services/AssetAccountsService';
import { AuthService } from './services/AuthService';
import { BackgroundJobsService } from './services/BackgroundJobsService';
import { CashflowsService } from './services/CashflowsService';
import { ClustersService } from './services/ClustersService';
import { CollectionPlansService } from './services/CollectionPlansService';
import { CommonService } from './services/CommonService';
import { DashboardsService } from './services/DashboardsService';
import { DatabasesService } from './services/DatabasesService';
import { DataExtractionService } from './services/DataExtractionService';
import { DefaultService } from './services/DefaultService';
import { DocumentationService } from './services/DocumentationService';
import { DocumentParseService } from './services/DocumentParseService';
import { DocumentsService } from './services/DocumentsService';
import { DocumentTagsService } from './services/DocumentTagsService';
import { EntitiesService } from './services/EntitiesService';
import { ExcelService } from './services/ExcelService';
import { ExtractionService } from './services/ExtractionService';
import { FieldsService } from './services/FieldsService';
import { FileIngestionService } from './services/FileIngestionService';
import { FilesService } from './services/FilesService';
import { FinancialsService } from './services/FinancialsService';
import { ForexService } from './services/ForexService';
import { HealthcheckService } from './services/HealthcheckService';
import { InboundEmailService } from './services/InboundEmailService';
import { IntercomService } from './services/IntercomService';
import { LuService } from './services/LuService';
import { McpService } from './services/McpService';
import { ModuleConfigsService } from './services/ModuleConfigsService';
import { MonitoringService } from './services/MonitoringService';
import { NamespacesService } from './services/NamespacesService';
import { NotificationsService } from './services/NotificationsService';
import { OrchestrationService } from './services/OrchestrationService';
import { PlaidService } from './services/PlaidService';
import { PropertiesService } from './services/PropertiesService';
import { RagService } from './services/RagService';
import { ReportFontsService } from './services/ReportFontsService';
import { ReportsService } from './services/ReportsService';
import { RolesService } from './services/RolesService';
import { SchedulesService } from './services/SchedulesService';
import { SigningService } from './services/SigningService';
import { TsmService } from './services/TsmService';
import { VersionService } from './services/VersionService';
import { WorkflowsService } from './services/WorkflowsService';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class PoliwrathClient {

    public readonly aiConcepts: AiConceptsService;
    public readonly apiKeys: ApiKeysService;
    public readonly assetAccounts: AssetAccountsService;
    public readonly auth: AuthService;
    public readonly backgroundJobs: BackgroundJobsService;
    public readonly cashflows: CashflowsService;
    public readonly clusters: ClustersService;
    public readonly collectionPlans: CollectionPlansService;
    public readonly common: CommonService;
    public readonly dashboards: DashboardsService;
    public readonly databases: DatabasesService;
    public readonly dataExtraction: DataExtractionService;
    public readonly default: DefaultService;
    public readonly documentation: DocumentationService;
    public readonly documentParse: DocumentParseService;
    public readonly documents: DocumentsService;
    public readonly documentTags: DocumentTagsService;
    public readonly entities: EntitiesService;
    public readonly excel: ExcelService;
    public readonly extraction: ExtractionService;
    public readonly fields: FieldsService;
    public readonly fileIngestion: FileIngestionService;
    public readonly files: FilesService;
    public readonly financials: FinancialsService;
    public readonly forex: ForexService;
    public readonly healthcheck: HealthcheckService;
    public readonly inboundEmail: InboundEmailService;
    public readonly intercom: IntercomService;
    public readonly lu: LuService;
    public readonly mcp: McpService;
    public readonly moduleConfigs: ModuleConfigsService;
    public readonly monitoring: MonitoringService;
    public readonly namespaces: NamespacesService;
    public readonly notifications: NotificationsService;
    public readonly orchestration: OrchestrationService;
    public readonly plaid: PlaidService;
    public readonly properties: PropertiesService;
    public readonly rag: RagService;
    public readonly reportFonts: ReportFontsService;
    public readonly reports: ReportsService;
    public readonly roles: RolesService;
    public readonly schedules: SchedulesService;
    public readonly signing: SigningService;
    public readonly tsm: TsmService;
    public readonly version: VersionService;
    public readonly workflows: WorkflowsService;

    public readonly request: BaseHttpRequest;

    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = AxiosHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '',
            VERSION: config?.VERSION ?? '0.0.1',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });

        this.aiConcepts = new AiConceptsService(this.request);
        this.apiKeys = new ApiKeysService(this.request);
        this.assetAccounts = new AssetAccountsService(this.request);
        this.auth = new AuthService(this.request);
        this.backgroundJobs = new BackgroundJobsService(this.request);
        this.cashflows = new CashflowsService(this.request);
        this.clusters = new ClustersService(this.request);
        this.collectionPlans = new CollectionPlansService(this.request);
        this.common = new CommonService(this.request);
        this.dashboards = new DashboardsService(this.request);
        this.databases = new DatabasesService(this.request);
        this.dataExtraction = new DataExtractionService(this.request);
        this.default = new DefaultService(this.request);
        this.documentation = new DocumentationService(this.request);
        this.documentParse = new DocumentParseService(this.request);
        this.documents = new DocumentsService(this.request);
        this.documentTags = new DocumentTagsService(this.request);
        this.entities = new EntitiesService(this.request);
        this.excel = new ExcelService(this.request);
        this.extraction = new ExtractionService(this.request);
        this.fields = new FieldsService(this.request);
        this.fileIngestion = new FileIngestionService(this.request);
        this.files = new FilesService(this.request);
        this.financials = new FinancialsService(this.request);
        this.forex = new ForexService(this.request);
        this.healthcheck = new HealthcheckService(this.request);
        this.inboundEmail = new InboundEmailService(this.request);
        this.intercom = new IntercomService(this.request);
        this.lu = new LuService(this.request);
        this.mcp = new McpService(this.request);
        this.moduleConfigs = new ModuleConfigsService(this.request);
        this.monitoring = new MonitoringService(this.request);
        this.namespaces = new NamespacesService(this.request);
        this.notifications = new NotificationsService(this.request);
        this.orchestration = new OrchestrationService(this.request);
        this.plaid = new PlaidService(this.request);
        this.properties = new PropertiesService(this.request);
        this.rag = new RagService(this.request);
        this.reportFonts = new ReportFontsService(this.request);
        this.reports = new ReportsService(this.request);
        this.roles = new RolesService(this.request);
        this.schedules = new SchedulesService(this.request);
        this.signing = new SigningService(this.request);
        this.tsm = new TsmService(this.request);
        this.version = new VersionService(this.request);
        this.workflows = new WorkflowsService(this.request);
    }
}

